import axios from 'axios'

/** The save was sent against a version that is no longer the latest: someone else saved meanwhile */
export function isSaveConflict(error: unknown) {
  return axios.isAxiosError(error) && error.response?.status === 409
}
